import PricesService from "../services/prices.service";

const state = {
	prices: [],
	updateResponse: '',
	updateResponseEx: '',
	departments: [],
	regNumber: '',
	docId: null,
	pricingList: [],
	editItems: [],
	updatePricingList: [],
	total: 0,
	lastItems: [],
	totalItems: 0,
	lastOriginalItems: [],
	pricingItemsTotal: 0,
	pricingItems: [],
	pricingItemsSection3: [],
	pricingItemsSection4: [],
	itemsForBacode: [],
	barcodeCount: 0,
	totalSection3: 0,
	totalSection4: 0
};

const getters = {
	getPrices: (state) => {
		return state.prices;
	},
	getDepartments: (state) => {
		return state.departments;
	},
	getRegNumber(state) {
		return state.regNumber;
	},
	getDocId(state) {
		return state.docId;
	},
	getPricing(state) {
		return state.pricingList;
	},
	getEditItems(state) {
		return state.editItems
	},
	getLastItems(state) {
		return state.lastItems;
	}
};


const actions = {
	async getLastItemList({commit}, data) {
		try {
			const items = await PricesService.lastPricing(data)
			commit('setLastPricing', items.data);
			return true
		} catch (e) {
			return false
		}
	},

	async getSearchGeneral({commit}, data) {
		try {
			const items = await PricesService.lastPricing(data)
			commit('setLastPricing', items.data.items);
			commit('setTotalItems', items.data.total);
			return true
		} catch (e) {
			return false
		}
	},
	async getSearchGeneralForWrapped({commit}, data) {
		try {
			const items = await PricesService.lastPricingForWrapped(data)
			commit('setLastPricing', items.data);
			return true
		} catch (e) {
			commit('setLastPricing', [])
			return false
		}
	},
	async getPricingItemsWithPagination({commit}, data) {
		try {
			const items = await PricesService.pricingItemsWithPagination(data)
			commit('setPricingItems', items.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getPricingItemsWithPaginationSection3({commit}, data) {
		try {
			const items = await PricesService.pricingItemsWithPaginationSection3(data)
			commit('setPricingItemsSection3', items.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getPricingItemsWithPaginationSection4({commit}, data) {
		try {
			const items = await PricesService.pricingItemsWithPaginationSection4(data)
			commit('setPricingItemsSection4', items.data);
			return true
		} catch (e) {
			return false
		}
	},

	async getUpdatePricing({commit}, data) {
		try {
			const items = await PricesService.updatePricing(data)
			commit('setUpdatePricing', items.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getEditPricing({commit}, id) {
		try {
			const prices = await PricesService.editPricing(id);
			commit('setEditPricing', prices.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getPricingAllList({commit}, paramsForUsers) {
		try {
			const prices = await PricesService.getPricingList(paramsForUsers);
			commit('setPricingList', prices.data);
			return true
		} catch (e) {
			return false
		}
	},
	// Add Action
	async getPricesList({commit}) {
		try {
			const prices = await PricesService.getPrices();
			commit('setPrices', prices.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getDepartmentList({commit}) {
		try {
			const departments = await PricesService.getDepartments();
			commit('setDepartments', departments.data);
			return true
		} catch (e) {
			return false
		}
	},
	async createPricesList({commit}, payload) {
		try {
			const response = await PricesService.createPrices(payload);
			commit('setUpdateResponse', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async createPricesExcel({commit}, payload) {
		try {
			const response = await PricesService.createPrices(payload);
			commit('setUpdateResponseExcel', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async createPricingDocForWrapped({commit}, payload) {
		try {
			const response = await PricesService.createPricingDocForWrapped(payload);
			commit('setUpdateResponse', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getRegNumberItem({commit}) {
		try {
			const regnumber = await PricesService.getRegNumber();
			commit('setRegNumber', regnumber.data);
			return true
		} catch (e) {
			return false
		}
	},

};

const mutations = {
	setPricingItemsSection4(state, res) {
		state.pricingItemsSection4 = res.items;
		state.totalsection4 = res.items;
	},
	setPricingItemsSection3(state, res) {
		state.pricingItemsSection3 = res.items;
		state.totalSection3 = res.total;
	},
	setLastPricing(state, items) {
		state.lastOriginalItems = JSON.stringify(items.slice());
		state.lastOriginalItems = JSON.parse(state.lastOriginalItems);
		state.lastItems = items
	},
	setTotalItems(state, total) {
		state.totalItems = total
	},
	setPricingItems(state, response) {
		state.pricingItems = response.items;
		state.pricingItemsTotal = response.total;
	},
	setUpdatePricing(state, item) {
		state.updatePricingList = item;
	},
	setPricingList(state, pricingList) {
		state.total = pricingList.total
		state.pricingList = pricingList.items;
	},
	setDepartments(state, departments) {
		state.departments = departments;
	},
	setPrices(state, prices) {
		state.prices = prices;
	},
	setUpdateResponse(state, response) {
		state.updateResponse = response
	},
	setUpdateResponseExcel(state, response) {
		state.updateResponseEx = response
	},
	setRegNumber(state, response) {
		state.regNumber = response
	},
	setDocId(state, response) {
		state.docId = response
	},
	setEditPricing(state, response) {
		state.editItems = response
	},
	setPricingForBarcode(state, items) {
		state.itemsForBacode = items;
	}
};

export const prices = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
